// Kannada translations
export const kn: Record<string, string> = {
  'menu.dashboard': 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
  'menu.customers': 'ಗ್ರಾಹಕರು',
  'menu.products': 'ಉತ್ಪನ್ನಗಳು',
  'menu.users': 'ಬಳಕೆದಾರರು',
  'menu.settings': 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
  'menu.logout': 'ಲಾಗ್ ಔಟ್',
  'dashboard.title': 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
  'dashboard.newOrder': 'ಹೊಸ ಆರ್ಡರ್',
  'order.title': 'ಹೊಸ ಆರ್ಡರ್',
  'order.customer': 'ಗ್ರಾಹಕ',
  'order.products': 'ಉತ್ಪನ್ನಗಳು',
  'order.total': 'ಒಟ್ಟು',
  'users.title': 'ಬಳಕೆದಾರರು',
  'users.name': 'ಹೆಸರು',
  'users.email': 'ಇಮೇಲ್',
  'common.yes': 'ಹೌದು',
  'common.no': 'ಇಲ್ಲ',
  'common.cancel': 'ರದ್ದುಮಾಡಿ',
  'common.save': 'ಉಳಿಸಿ',
  'common.search': 'ಹುಡುಕಿ',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'ಲಾಗಿನ್',
  'login.welcome': 'ಸುಸ್ವಾಗತ, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'ಇಮೇಲ್',
  'signup.phone': 'ಫೋನ್',
  'menu.reportsAndAccounting': 'ವರದಿಗಳು ಮತ್ತು ಲೆಕ್ಕಪತ್ರ',
  'menu.systemAndCommunication': 'ವ್ಯವಸ್ಥೆ ಮತ್ತು ಸಂವಹನ',
};